// extracted by mini-css-extract-plugin
module.exports = {"work-report":"style-module__work-report___1SphO","loading-text":"style-module__loading-text___1zHHl"};